import { NumCatalogResponse } from '@/shared/state/api/swagger';

export const selectNumOptions = (nums: NumCatalogResponse[] = []) =>
	nums.map((num) => ({
		value: num.id,
		label: num.num,
	})) || [];
